import { render, staticRenderFns } from "./BaseCompletePage.vue?vue&type=template&id=b70db2ce&scoped=true&"
import script from "./BaseCompletePage.vue?vue&type=script&lang=js&"
export * from "./BaseCompletePage.vue?vue&type=script&lang=js&"
import style0 from "./BaseCompletePage.vue?vue&type=style&index=0&id=b70db2ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70db2ce",
  null
  
)

export default component.exports